import React, {useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import RadioComponent from 'pu-react/components/RadioComponent';
import Label from 'pu-react/components/Label';
import ConfirmModal from 'pu-react/components/ConfirmModal';

import { changeStencilsSide } from '../stencilSlice';

import sides from '../data/StencilsSides';
import { TWO_SIDES, COMBINED } from '../data/StencilsConstants';

const StencilsSide = ({label, required}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [new_side_selection, setNewSideSelection] = useState(null);

  const {
    stencils,
    stencilsSide,
  } = useSelector((state) => state.smtStencil);

  const onChange = (new_side) => {
    if(stencilsSide == TWO_SIDES && new_side == COMBINED && stencils.filter((s) => {
        const { stencil_side, ...check_parameters } = s.parameters;
        return !_.isEmpty(check_parameters);
      }).length > 0){
      setShow(true);
      setNewSideSelection(new_side);
      return;
    }
    dispatch(changeStencilsSide(new_side))
  }

  const onClickYes = () => {
    dispatch(changeStencilsSide(new_side_selection))
    setShow(false);
  }

  const items = sides.map((side) => {
    return (
      <RadioComponent
        key={side.key}
        name="stencil_side"
        inputId={`stencils-side-${side.key}`}
        label={side.label}
        checked={stencilsSide === side.key}
        onChange={() => onChange(side.key)} />
    )
  });

  return (
    <>
      <div className="form-group">
        <Label label={label} required={required} />
        {items}
      </div>
      <ConfirmModal
        className="tab-stencils-confirm-modal"
        size="lg"
        show={show}
        labelYes="Yes"
        labelNo="No"
        onClickYes={() => onClickYes()}
        onClickNo={() => setShow(false)}>
          <h4 className="fw-bold mb-3">WARNING</h4>
          <p className="text-center">
            You are about to change the stencil side(s) from two stencils to combined stencil.<br/>
            This will fill all the parameters for the combined stencil using the top stencil form.<br/>
            Are you sure you want to continue?
          </p>
      </ConfirmModal>
    </>
    
  )
}

StencilsSide.defaultProps = {
  label: 'Stencil Side(s)',
  required: false,
}

export default StencilsSide
